import { render, staticRenderFns } from "./ManageUserPermissions.vue?vue&type=template&id=295885e9&scoped=true"
import script from "./ManageUserPermissions.vue?vue&type=script&lang=js"
export * from "./ManageUserPermissions.vue?vue&type=script&lang=js"
import style0 from "./ManageUserPermissions.vue?vue&type=style&index=0&id=295885e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295885e9",
  null
  
)

export default component.exports